<div [formGroup]="cristalForm">
  <div class="mb-3">
    <label class="fw-semibold small">Foto del cristal roto *</label>
    <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleGlassPicture)" (onremovefile)="handleRemoveImage($event)"
               [options]="picOptions">
    </file-pond>
  </div>
  <div class="mb-3">
    <label class="fw-semibold small">Foto numeración del chasis *</label>
    <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleVinPicture)" (onremovefile)="handleRemoveImage($event)"
               [options]="picOptions">
    </file-pond>
  </div>
  <div class="mb-3">
    <label class="fw-semibold small">Foto de la placa *</label>
    <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehiclePlatePicture)" (onremovefile)="handleRemoveImage($event)"
               [options]="picOptions">
    </file-pond>
  </div>
</div>
